import Api from "@/api"
import { IconButton } from "@/components/form"
import { MarriageStatus, type FormSection, type MarriageClaimInitialData } from "@/models"
import { faFileImport } from "@fortawesome/free-solid-svg-icons"
import tinycolor from "tinycolor2"
import { css } from "vite-css-in-js"
import { defineComponent, downloadFile, inferProps, ShadowContainer, type ReactiveComponent } from "vue-utils"

interface Props {
	sections: FormSection[]
	claimData: MarriageClaimInitialData
}

const buttonStyles = css`
	display: flex;
	flex-direction: column;
	gap: 1rem;

	button:hover {
		background-color: var(--hover-color) !important;
	}
`

const DetailNavigation: ReactiveComponent<Props> = (props) => {
	async function savePdf() {
		const data = await Api.marriageClaims.fillPdfWithClaim(props.claimData.claim)
		await downloadFile(data, `${props.claimData.claim.ClaimRef}-MATCF-Filled.pdf`)
	}
	return () => (
		<ShadowContainer class="d-flex flex-column h-100">
			<div>
				<h5>Page Navigation</h5>
				<hr />
			</div>
			<div class="d-flex flex-column flex-grow-1 justify-content-between">
				<div class={buttonStyles}>
					{props.sections.map((section) => (
						<IconButton
							key={section.id}
							class="w-100 justify-content-start"
							style={`color: black; border-color:white; background-color: ${section.color}; --hover-color: ${tinycolor(section.color).saturate(0).lighten(15).toHexString()} `}
							icon={section.icon}
							color="primary"
							onClick={() => (window.location.href = `#${section.id}`)}
						>
							{section.name}
						</IconButton>
					))}
				</div>
				<div>
					<hr />
					<IconButton
						class="w-100"
						icon={faFileImport}
						color="success"
						onClick={() => void savePdf()}
						disabled={props.claimData.claim.Status !== MarriageStatus.P2Complete}
					>
						Send Data to PDF
					</IconButton>
				</div>
			</div>
		</ShadowContainer>
	)
}

export default defineComponent(DetailNavigation, inferProps<Props>())
